// Czytamy env vars z import.meta.env (Vite expose tylko VITE_*).
// ZASADA: zaden URL nie jest hardkodowany. Wszystko przez .env -> import.meta.env.

interface ClientConfig {
  readonly pusherHost: string;
  readonly pusherAppKey: string;
  readonly apiBase: string;
  readonly mode: "development" | "production";
}

function requireEnv(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key];
  if (typeof value !== "string" || value.length === 0) {
    throw new Error(`Brak wymaganego env vars: ${String(key)}. Sprawdz .env w roocie monorepo.`);
  }
  return value;
}

export const config: ClientConfig = {
  pusherHost: requireEnv("VITE_PUSHER_HOST"),
  pusherAppKey: requireEnv("VITE_PUSHER_APP_KEY"),
  apiBase: import.meta.env["VITE_API_BASE"] ?? "/api",
  mode: import.meta.env["MODE"] === "production" ? "production" : "development",
};
